export const HOLD_MUSIC_PATH = 'holdMessage.message';
export const QUEUE_URL_PATH = 'queueUrl';
export const IVR_ID_PATH = 'initialIvrId';
export const IVR_WAIT_DURATION_PATH = 'queueIvrWaitDuration';
export const QUEUE_IVR_PATH = 'queueIvrId';
